import React, { useRef, useState } from 'react'
import s from './dropdown.module.scss'
import { IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import { useClickOutside } from '@utils/lib/useClickOutside';

// Опции — строки либо объекты { label, image? } (аватарка слева от текста).
const getOptionLabel = (option) => (typeof option === 'object' ? option?.label : option);

export const Dropdown = ({ label, options, value, onChange, className, buttonClassName }) => {
  const [isOpen, setOpen] = useState(false);
  const menuRef = useRef(null);

  useClickOutside(menuRef, () => setOpen(false));

  const handleSelect = (option) => {
    onChange?.(option);
    setOpen(false);
  };

  return (
    <div className={`${s.wrapper} ${className ?? ""}`} ref={menuRef}>
      <button
        type="button"
        className={`${s.button} ${isOpen ? s.active : ""} ${buttonClassName ?? ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className={`${s.label} ${value !== null && value !== undefined && value !== "" ? s.hasValue : ""}`}>{value ?? label}</span>
        <IconChevronDown size={18} className={s.arrowDown} />
        <IconChevronUp size={18} className={s.arrowUp} />
      </button>

      <nav className={`${s.menu} ${isOpen ? s.active : ""}`}>
        <ul className={s.list}>
          {options?.map((option) => {
            const optionLabel = getOptionLabel(option);
            const optionImage = typeof option === 'object' ? option?.image : null;

            return (
              <li
                key={optionLabel}
                className={`${s.item} ${optionLabel === value ? s.selected : ""}`}
                onClick={() => handleSelect(option)}
              >
                {optionImage && (
                  <img className={s.optionAvatar} src={optionImage} alt="" />
                )}
                <span>{optionLabel}</span>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
